import { v4 as uuidv4 } from 'uuid';
import Storage from './Storage';

const CLIENT_ID_KEY = `${process.env.REACT_APP_FIRESTORE_DB_ENV_VERSION_NAME}-client-id`;

export const getClientId = () => {
    let clientId = Storage.getItem(CLIENT_ID_KEY);

    if (clientId) {
        return clientId;
    }

    clientId = uuidv4();

    Storage.setItem(CLIENT_ID_KEY, clientId);

    return clientId;
};

export const removeClientId = () => {
    Storage.removeItem(CLIENT_ID_KEY);
};

export const generateClientId = (): string => {
    removeClientId();

    return getClientId();
};
